<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <h2 class="mb-5">
        {{ inputs.language === 'en' ? 'Experiment 6: Question 4' : 'Expérience 6: Question 4' }}
      </h2>

      <p class="mb-n3">
        {{
          inputs.language === 'en'
            ? 'In a reagent table, what is the meaning of equivalents?'
            : 'Dans un tableau des reactifs, quelle est la signification des equivalences?'
        }}
      </p>

      <v-radio-group v-model="inputs.studentAnswer" :disabled="!allowEditing" class="mb-0 pl-6">
        <v-radio
          v-for="option in inputs.language === 'en' ? optionsShuffled : optionsShuffledFr"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <v-btn-toggle
        v-model="inputs.language"
        class="ml-2"
        size="small"
        dense="dense"
        rounded="rounded"
        mandatory
      >
        <v-btn :value="'en'">English</v-btn>
        <v-btn :value="'fr'">Français</v-btn>
      </v-btn-toggle>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';
export default {
  name: 'uOttawa1321Prelab6Q4',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        studentAnswer: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      options: [
        {
          text: 'Molar ratio of each reactant with respect to the limiting reagent',
          value: 'molarRatioEachReactant',
        },
        {
          text: 'Mass ratio of each reactant with respect to the limiting reagent',
          value: 'massRatioEachReactant',
        },
        {
          text: 'Molar ratio of the work-up reagents with respect to the limiting reagent',
          value: 'molarRatioWorkupReagents',
        },
        {
          text: 'Mass ratio of the work-up reagents with respect to the limiting reagent',
          value: 'massRatioWorkupReagents',
        },
        {
          text: 'Molar ratio of each reagent with respect to the solvent',
          value: 'molarRatioSolvent',
        },
        {
          text: 'Mass ratio of each reagent with respect to the solvent',
          value: 'massRatioSolvent',
        },
      ],
      optionsFr: [
        {
          text: 'Ratio molaire de chacun des réactifs par rapport au réactif limitant',
          value: 'molarRatioEachReactant',
        },
        {
          text: 'Ratio massique de chacun des réactifs par rapport au réactif limitant',
          value: 'massRatioEachReactant',
        },
        {
          text: 'Ratio molaire de chacun des réactifs du parachèvement par rapport au réactif limitant',
          value: 'molarRatioWorkupReagents',
        },
        {
          text: 'Ratio massique de chacun des réactifs du parachèvement par rapport au réactif limitant',
          value: 'massRatioWorkupReagents',
        },
        {
          text: 'Ratio molaire de chacun des réactifs par rapport au solvant',
          value: 'molarRatioSolvent',
        },
        {
          text: 'Ratio massique de chacun des réactifs par rapport au solvant',
          value: 'massRatioSolvent',
        },
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
    optionsShuffledFr() {
      return seededShuffle(this.optionsFr, this.seed);
    },
  },
};
</script>
